<template>
  <div class="mt-5">
    <v-layout>
      <v-flex>
        <v-btn flat @click="onBack">
          <i class="fas fa-chevron-left mr-1"></i>
          {{ $t('Back') }}
        </v-btn>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-btn outline color="grey" @click="onSave">
          <i class="fas fa-save mr-1"></i>
          {{ $t('save draft') }}
        </v-btn>
        <v-btn depressed color="primary" @click="onSend">
          <i class="fas fa-paper-plane mr-1"></i>
          {{ $t('Send') }}
        </v-btn>
      </v-flex>
    </v-layout>

    <v-container>
      <h3 class="headline">{{ $t('Broadcast Detail') }}</h3>
    </v-container>
    <template v-if="broadcast">
      <v-container>
        <div>{{ $t('Broadcast Name') }}</div>
        <div class="form-control" :class="{ 'has-error': errors.has('broadcastName') }">
          <input
            type="text"
            class="form-control"
            name="broadcastName"
            data-vv-name="broadcastName"
            :data-vv-as="$t('Broadcast Name')"
            :placeholder="$t('Broadcast Name')"
            v-validate="'required'"
            v-model="name"
          />
          <span class="text-error" v-show="errors.has('broadcastName')">{{
            errors.first('broadcastName')
          }}</span>
        </div>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <div>{{ $t('Message Type') }}</div>
        <v-radio-group v-model="sendtype" row>
          <v-radio :label="$t('Promotion')" value="promotion" color="primary"></v-radio>
          <!-- <v-radio :label="$t('Subscription')" value="subscription" color="primary"></v-radio> -->
        </v-radio-group>
        <!-- <div v-show="sendtype == 'subscription'">
          <div class="warning-message" style="margin: 0;display: flex">
            <vue-simple-svg
              :filepath="'/static/img/assets/_global/warning.svg'"
              width="30px"
              height="auto"
              class="icon"
            />
            <div style="padding-left: 10px">
              <template>
                {{$t('Before using this feature, please apply Facebook Page Subscription')}}
                <a
                  href="https://blog.zwiz.ai/tutorial-4-broadcast-%E0%B8%9A%E0%B8%A3%E0%B8%AD%E0%B8%94%E0%B9%81%E0%B8%84%E0%B8%AA%E0%B8%95%E0%B9%8C/"
                  target="_blank"
                  rel="noopener noreferrer"
                >{{$t('See How do I apply to send subscription messages?')}}</a>
                {{$t('You cannot broadcast promotional message. Your page might be blocked by Facebook if you broadcast promotional messages or when user report that they receive too many messages.')}}
                <a
                  href="https://developers.facebook.com/docs/messenger-platform/policy/policy-overview/#subscription_messaging"
                  target="_blank"
                  rel="noopener noreferrer"
                >{{$t('See guideline for more information')}}</a>
              </template>
            </div>
          </div>
        </div>-->
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <div>{{ $t('Notification Setting') }}</div>
        <v-radio-group v-model="pushtype" row>
          <v-radio
            :label="$t('silent push')"
            value="SILENT_PUSH"
            color="primary"
            v-tooltip.top="
              $t(
                'Silent Push notification will display a phone notification without sound. Use it for regular messages that dont require immediate action.'
              )
            "
          ></v-radio>
          <v-radio
            :label="$t('regular push')"
            value="REGULAR"
            color="primary"
            v-tooltip.top="
              $t(
                'Regular Push notification will make a sound and display a phone notification. Use it for important messages.'
              )
            "
          ></v-radio>
          <v-radio
            :label="$t('no push')"
            value="NO_PUSH"
            color="primary"
            v-tooltip.top="
              $t(
                'No Push notification will not display a phone notification and make any sound. Use it for messages that dont require immediate action.'
              )
            "
          ></v-radio>
        </v-radio-group>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <div>{{ $t('Target') }}</div>
        <template v-if="loadingEstimate">
          <sync-loader
            :color="$vuetify.theme.primary"
            :size="'8px'"
            style="display:inline-block;margin-bottom: 10px"
          ></sync-loader>
        </template>
        <template v-else>
          <p class="primary-color">
            {{ $t('approximately') }}
            <tween-num
              :value="parseInt(estimate_user)"
              :initial="0"
              :formatter="numberFormat"
            ></tween-num>
            <span>&nbsp;{{ $t('users') }}</span>
          </p>
          <p>
            ***
            {{
              $t(
                'A premium package must be upgraded before the chatbot will be able to import the previous users'
              )
            }}
          </p>
        </template>
        <multiselect
          v-model="groupType"
          :options="groupTypeOptions"
          label="label"
          :allow-empty="false"
          :searchable="false"
          selectLabel
          selectedLabel
          deselect-label
          track-by="label"
          @select="onSelectGroupType"
        ></multiselect>

        <div style="position:relative" v-if="groupType.value == 'customize'">
          <div class="form-control">
            <v-premium-plan-popup
              :showAll="false"
              marginTop="65"
              v-if="$store.getters.getPackage != 'premium' || isCoachlab"
            ></v-premium-plan-popup>
            <template>
              <div
                style="border: 1px solid #eee;padding: 5px 10px 0px 10px;border-radius: 10px;margin-top: 15px;background: #fbfbfb"
              >
                <filter-customer
                  v-model="filter"
                  @onChangeStatus="onChangeStatus"
                ></filter-customer>
              </div>
            </template>
          </div>
        </div>
      </v-container>
      <v-divider></v-divider>

      <v-container>
        <template v-if="type == 'json'">
          <div>
            <intent-group
              v-model="messages"
              :hasAlternative="false"
              :isWelcome="true"
            ></intent-group>
          </div>
          <div>
            <p class="small" style="margin-top: 10px;">{{ $t('Choice') }}</p>
            <div class="form-control" :class="{ 'has-error': errorTag.length > 0 }">
              <tags
                v-model="choice"
                :tags="choices"
                @tags-changed="addChoices"
                @before-adding-tag="checkQuickReply"
                style="margin-bottom: 5px;"
                :btnText="$t('Add choice')"
              ></tags>

              <span class="text-error" v-if="errorTag.length > 0">
                <template v-if="errorTag.includes('overmaxlength')">{{
                  $t('Message cannot be longer than 20 alphabets')
                }}</template>
                <template v-else-if="errorTag.includes('overtagmax')">{{
                  $t('Choices cannot be more than 10 items')
                }}</template>
                <template v-else-if="errorTag.includes('duplicate')">{{
                  $t('Duplicate Choice')
                }}</template>
              </span>
            </div>
          </div>
          <div class="clearfix"></div>
        </template>
        <template v-else-if="type == 'template'">
          <div style="overflow-x:scroll;margin-bottom:5px;">
            <div
              style="margin:0;overflow:auto;"
              :style="{ width: generics.length * 315 + (generics.length < 10 ? 315 : 0) + 'px' }"
            >
              <div
                style="float:left;width:300px;margin-right: 15px;"
                v-for="(generic, index) in generics"
                :key="'generic_' + index"
              >
                <generic-manage
                  :vkey="index"
                  v-model="generics[index]"
                  @onDelete="onDeleteGeneric(index)"
                  :isValidate="true"
                >
                  <move-horizontal
                    slot="move"
                    :index="index"
                    :max="generics.length"
                    @onMove="onMove(index, $event)"
                  ></move-horizontal>
                </generic-manage>
              </div>
              <div
                v-if="generics.length < 10"
                @click="addGeneric"
                style="position:relative;float:left;width:300px;border: 4px dashed #eee;border-radius: 20px;height: 300px;cursor:pointer"
              >
                <div
                  style="position:absolute;left: 50%;top: 50%;margin-left: -10px;margin-top: -23px;font-size: 32px;"
                >
                  <span class="glyphicon glyphicon-plus"></span>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </template>
      </v-container>

      <template>
        <v-divider></v-divider>
        <div style="position:relative">
          <v-premium-plan-popup
            :showAll="false"
            v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          ></v-premium-plan-popup>
          <v-container
            :style="{
              'min-height': $store.getters.getPackage != 'premium' || isCoachlab ? '230px' : 'auto'
            }"
          >
            <v-layout>
              <v-flex>{{ $t('Schedule Broadcast') }}</v-flex>
              <v-flex class="text-xs-right">
                <label class="toggle-switch small" style="vertical-align: bottom;">
                  <input
                    type="checkbox"
                    :checked="broadcast.isschedule"
                    @change="onBroadcastSchedule"
                  />
                  <span class="toggle-slider lever round"></span>
                </label>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="broadcast.isschedule">
              <v-flex xs6 class="form-control">
                <v-layout wrap>
                  <v-flex xs8>
                    <v-menu
                      ref="showScheduleDate"
                      v-model="showScheduleDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <input type="text" name id v-model="scheduleDate" v-on="on" readonly />
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="scheduleDate"
                        @input="showScheduleDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="showScheduleTime"
                      v-model="showScheduleTime"
                      :close-on-content-click="false"
                      :return-value.sync="scheduleTime"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <input type="text" name id v-model="scheduleTime" readonly v-on="on" />
                      </template>
                      <v-time-picker
                        v-if="showScheduleTime"
                        v-model="scheduleTime"
                        full-width
                        @click:minute="$refs.showScheduleTime.save(scheduleTime)"
                        color="primary"
                        :allowed-minutes="allowedStep"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>

      <v-container>
        <br />
        <div class="text-xs-center" style="margin-bottom: 10px;">
          <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
            <i class="far fa-eye"></i>
            {{ $t('preview') }}
          </a>
          <preview-message
            v-if="showPreview"
            @close="showPreview = false"
            :messages="messages"
            :choice="choices"
            :questions="questions"
            :isComment="false"
            :comment="''"
          ></preview-message>
          <input
            type="hidden"
            v-validate="'min_value:1'"
            :name="'messages'"
            v-model="messages[0].length"
            :data-vv-as="$t('Broadcast Messages')"
          />
          <div class="form-control mt-4" :class="{ 'has-error': errors.has('messages') }">
            <span class="text-error" v-show="errors.has('messages')">{{
              errors.first('messages')
            }}</span>
          </div>
        </div>
        <div class="text-xs-center mt-2">
          <v-btn color="grey" outline @click="onBack">
            <i class="fas fa-chevron-left mr-1"></i>
            {{ $t('Back') }}
          </v-btn>
          <v-btn color="grey" outline @click="onSave">
            <i class="fas fa-save mr-1"></i>
            {{ $t('save draft') }}
          </v-btn>
          <v-btn depressed @click="onSend" color="primary">
            <i class="fas fa-paper-plane mr-1"></i>
            {{ $t('Send') }}
          </v-btn>
        </div>
      </v-container>
    </template>

    <modal-dialog2 v-if="showUpgrade" @close="showUpgrade = false">
      <div slot="body" style="overflow: auto">
        <div style="position: relative">
          <v-premium-plan-popup :inline="true" backgroundColor="white"></v-premium-plan-popup>
        </div>
      </div>

      <div slot="footer">
        <div class="text-xs-center">
          <button
            type="button"
            class="btn btn-flat"
            data-dismiss="modal"
            @click="showUpgrade = false"
          >
            {{ $t('cancel') }}
          </button>
        </div>
      </div>
    </modal-dialog2>
  </div>
</template>
<script>
import api from '@/api'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import numeral from 'numeral'
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import datepicker from 'vuejs-datepicker'
import IntentGroup from '@/components/view/intent/IntentGroup'
import GenericManage from '@/components/elements/GenericManage'
import MoveHorizontal from '@/components/elements/MoveHorizontal'
import TweenNum from 'vue-tween-number'
import ModalDialog2 from '@/components/elements/ModalDialog2'
// import { constants } from 'http2';
import Tags from '@/components/elements/Tags'
import Multiselect from 'vue-multiselect'
import PreviewMessage from '@/components/elements/PreviewMessage'
import FilterCustomer from '@/components/elements/FilterCustomer'

export default {
  props: ['value'],

  data: function() {
    return {
      showScheduleDate: false,
      showScheduleTime: false,
      scheduleDate: null,
      scheduleTime: null,

      showPreview: false,
      questions: [],
      tag: '',
      singleStatus: '',
      showUpgrade: false,
      broadcast: undefined,
      isSave: false,
      isFail: false,
      name: '',
      localeOptions: config.locale,
      symbolOptions: [
        {
          value: 'g__',
          label: this.$t('Greater than')
        },
        {
          value: 'l__',
          label: this.$t('Less than')
        },
        {
          value: 'n__',
          label: this.$t('Not')
        }
      ],
      groupTypeOptions: [
        {
          label: this.$t('All'),
          value: ''
        },
        {
          label: this.$t('Facebook'),
          value: 'facebook'
        },
        {
          label: this.$t('Line'),
          value: 'line'
        },
        {
          label: this.$t('Customize'),
          value: 'customize'
        }
      ],
      intents: [],
      type: 'json',
      groupType: {
        label: this.$t('All'),
        value: ''
      },
      sendtype: 'promotion',
      pushtype: 'SILENT_PUSH', // REGULAR/SILENT_PUSH/NO_PUSH
      message: '',
      quick_reply: '',
      messages: [[]],
      choice: '',
      channelOptions: [
        {
          label: this.$t('All'),
          value: 'all'
        },
        {
          label: this.$t('Facebook'),
          value: 'facebook'
        },
        {
          label: this.$t('Line'),
          value: 'line'
        }
      ],
      genderOptions: [
        {
          label: this.$t('All'),
          value: 'all'
        },
        {
          label: this.$t('Male'),
          value: 'male'
        },
        {
          label: this.$t('Female'),
          value: 'female'
        },
        {
          label: this.$t('no gender'),
          value: 'other'
        }
      ],
      generics: [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        }
      ],
      filter: {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        tags: '',
        status: ''
      },
      errorTag: [],
      errorFilterTag: [],
      errorFilterStatus: [],
      estimate_user: 0,
      loadingEstimate: true
    }
  },
  components: {
    datepicker,
    IntentGroup,
    GenericManage,
    MoveHorizontal,
    TweenNum,
    SyncLoader,
    ModalDialog2,
    Tags,
    Multiselect,
    PreviewMessage,
    FilterCustomer
  },
  mounted: function() {
    var vm = this

    vm.reset()

    if (vm.name === '') {
      vm.name = 'Broadcast_' + moment().format('YYYY_MM_DD_HH_mm')
    }

    if (vm.broadcast.scheduletime) {
      var scheduleDate = moment(vm.broadcast.scheduletime)
      vm.scheduleDate = scheduleDate.format('YYYY-MM-DD')
      vm.scheduleTime = scheduleDate.format('HH:mm')
    } else {
      var scheduleDate = moment()
      vm.scheduleDate = scheduleDate.format('YYYY-MM-DD')
      vm.scheduleTime = scheduleDate.format('HH') + ':' + '00'
    }

    vm.$nextTick(function() {
      if (vm.groupType.value === 'customize') {
        if (vm.$store.getters.getPackage === 'premium' && !vm.isCoachlab) {
          vm.estimateReach(vm.groupType.value)
        } else {
          vm.estimateReach('')
        }
      } else {
        vm.estimateReach(vm.groupType.value)
      }
    })
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus',
      isCoachlab: 'isCoachlab'
    }),
    filterIntent: function() {
      var vm = this
      if (vm.intents && vm.intents.length > 0) {
        vm.intents.sort(function(a, b) {
          var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
          var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
          if (a.intentname[0] === '{' && a.intentname[a.intentname.length - 1] === '}') {
            return 1
          }
          if (b.intentname[0] === '{' && b.intentname[b.intentname.length - 1] === '}') {
            return -1
          }
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }

          // names must be equal
          return 0
        })
      }
      var intents = []
      if (vm.intents) {
        vm.intents.map(function(intent, index) {
          intents.push(intent.intentname)
        })
      }
      return intents
    },
    choices: {
      get() {
        let vm = this
        if (vm.quick_reply && vm.quick_reply !== '') {
          // console.log(vm.quick_reply)
          var quickReplies = []
          quickReplies = vm.quick_reply.split(',')
          var result = []
          if (quickReplies) {
            quickReplies.map(function(val, index) {
              result.push({ text: val })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(val, index) {
            result.push(val.text)
          })
        }
        vm.quick_reply = result.join(',')
      }
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            tags.map(function(tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      }
    },
    status: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.status && vm.filter.status !== '') {
          var status = []
          status = vm.filter.status.split(',')
          var result = []
          if (status) {
            status.map(function(s, index) {
              result.push({ text: s })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(s, index) {
            result.push(s.text)
          })
        }
        vm.filter.status = result.join(',')
      }
    }
  },
  methods: {
    allowedStep: m => m % 10 === 0,
    onChangeStatus() {
      if (this.groupType === 'customize') {
        if (this.$store.getters.getPackage === 'premium' && !this.isCoachlab) {
          this.estimateReach(this.groupType)
        } else {
          this.estimateReach('')
        }
      } else {
        this.estimateReach(this.groupType)
      }
    },
    onBroadcastSchedule() {
      // this.broadcast.isschedule = !this.broadcast.isschedule
      this.$set(this.broadcast, 'isschedule', !this.broadcast.isschedule)
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 20) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function(newTags) {
      this.tags = newTags
    },
    checkStatus(obj) {
      this.errorFilterStatus = []
      if (obj.tag.text.length > 20) {
        this.errorFilterStatus.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterStatus.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addStatus: function(newTags) {
      this.status = newTags
    },
    addChoices: function(newTags) {
      this.choices = newTags
    },
    checkQuickReply(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (this.choices.length >= 10) {
        this.errorTag.push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        // this.choices.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    numberFormat: function(val) {
      return numeral(val).format('0,0')
    },
    getIntent: function(callback) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid
      }
      api.getIntent(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          response.data.map(function(val, index) {
            var intent = val
            vm.intents.push(intent)
          })
        }
        callback()
      })
    },
    onActiveStartDate: function(value) {
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
    },
    onActiveEndDate: function(value) {
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
    },
    onRegisterStartDate: function(value) {
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
    },
    onRegisterEndDate: function(value) {
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
    },
    onOptionChange: function(option) {
      this.type = option
      // this.saveWelcomeMessage()
    },
    onDeleteGeneric: function(index) {
      if (this.generics.length > 1) {
        this.generics.splice(index, 1)
      } else {
        alert('Generic Message cannot be less than 1')
      }
    },
    onMove: function(index, direction) {
      var vm = this
      if (direction === 'left') {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction === 'right') {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
    },
    addGeneric: function() {
      if (this.generics.length < 10) {
        this.generics.push({
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        })
      }
    },
    onBack: function() {
      var vm = this
      vm.$emit('onClose')
    },
    onSave: function() {
      var vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()

          return false
        }
        // if (vm.groupType == 'customize' && vm.$store.getters.getPackage != 'premium') {
        //     vm.showUpgrade = true
        //     return false
        // }
        vm.$store.dispatch('loading')
        vm.updateBroadcast(false, function(status) {
          if (status) {
            vm.$swal.fire({
              title: vm.$t('Success! Broadcast {name} save', {
                name: vm.name.replace(/\<|\>/g, '')
              }),
              type: 'success',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
          } else {
            vm.$swal.fire({
              title: vm.$t('Oop! Broadcast {name} save draft fail', {
                name: vm.name.replace(/\<|\>/g, '')
              }),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
          }

          $('html, body').animate({ scrollTop: 0 })

          vm.$store.dispatch('loading')
        })
      })
    },
    onSend: function() {
      var vm = this

      vm.$validator.validateAll().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.groupType.value === 'customize' && vm.$store.getters.getPackage !== 'premium') {
          vm.showUpgrade = true
          return false
        }
        vm.$swal
          .fire({
            title: vm.$t('Do you want to broadcast {name}?', {
              name: vm.name.replace(/\<|\>/g, '')
            }),
            html: `<small><b>${vm.$t('Notice !')}</b>${vm.$t(
              'If you send too many broadcasts,your inbox might not be able to access temporarily.'
            )}<small>`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          .then(result => {
            if (result.value) {
              vm.$store.dispatch('loading')
              vm.updateBroadcast(true, function(status) {
                if (status) {
                  vm.$swal
                    .fire({
                      title: vm.$t('Broadcast {sent_name} sent', {
                        sent_name: vm.name.replace(/\<|\>/g, '')
                      }),
                      type: 'success',
                      confirmButtonText: vm.$t('Confirm'),
                      cancelButtonText: vm.$t('cancel'),
                      reverseButtons: true
                    })
                    .then(function() {
                      vm.$emit('onClose', vm.name)
                    })
                } else {
                  vm.$swal.fire({
                    title: vm.$t('Oop! Broadcast {name} save draft fail', {
                      name: vm.name.replace(/\<|\>/g, '')
                    }),
                    type: 'error',
                    confirmButtonText: vm.$t('Confirm'),
                    cancelButtonText: vm.$t('cancel'),
                    reverseButtons: true
                  })
                }
                vm.$store.dispatch('loading')
              })
            }
          })
      })
    },
    updateBroadcast: function(isSend, callback) {
      var vm = this
      var vm = this
      var scheduletime = moment(vm.scheduleDate + ' ' + vm.scheduleTime)
      var scheduletimeUTC = moment.utc(scheduletime)
      var data = {
        pageid: vm.selectedBot.pageid,
        name: vm.name,
        m_val: vm.message,
        m_type: 'json',
        m_quick_reply: vm.quick_reply,
        m_condition: '',
        sendflag: isSend,
        page_access_token: vm.selectedBot.page_access_token,
        pushtype: vm.pushtype,
        sendtype: vm.sendtype
      }
      if (vm.$store.getters.getPackage == 'premium' && !vm.isCoachlab) {
        data.isschedule = vm.broadcast.isschedule
        data.scheduletime = scheduletimeUTC.format('YYYY-MM-DDTHH:mm:ss.sssZ')
      } else {
        data.isschedule = false
        data.scheduletime = null
      }
      if (vm.groupType.value === 'facebook') {
        data.m_condition = 'app=facebook'
      } else if (vm.groupType.value === 'line') {
        data.m_condition = 'app=line'
      } else if (vm.groupType.value === 'customize') {
        data.filter = vm.filter
      }

      if (vm.broadcast && vm.broadcast.id) {
        data.broadcastid = vm.broadcast.id
      }

      if (data.m_type === 'json') {
        data.m_val = JSON.stringify(vm.messages)
      }

      vm.$emit('onSave', {
        data: data,
        onSave: function(status, broadcastid) {
          if (status) {
            if (broadcastid) {
              data.id = broadcastid
            }
            vm.broadcast = data
            vm.cached_broadcast = Object.assign({}, vm.broadcast)
          }
          callback(status)
        }
      })
    },
    estimateReach: function(type) {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }
      if (type === 'customize') {
        data.filter = vm.filter
      } else {
        if (type === 'facebook') {
          data.condition = '&app=facebook'
        } else if (type === 'line') {
          data.condition = '&app=line'
        } else {
          data.condition = ''
        }
      }
      vm.loadingEstimate = true
      api.estimateReach(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.loadingEstimate = false
          return
        }
        if (response.data) {
          vm.estimate_user = response.data.count
        } else {
          vm.estimate_user = 0
        }
        vm.$nextTick(function() {
          vm.loadingEstimate = false
        })
      })
    },
    onSelectGroupType: function(type) {
      if (type.value === 'customize') {
        if (this.$store.getters.getPackage === 'premium' && !this.isCoachlab) {
          this.estimateReach(type.value)
        } else {
          this.estimateReach('')
        }
      } else {
        this.estimateReach(type.value)
      }
    },
    reset: function() {
      var vm = this
      vm.getIntent(function() {})
      if (vm.value) {
        vm.broadcast = Object.assign({}, vm.value)
        vm.cached_broadcast = Object.assign({}, vm.value)

        var filters = vm.broadcast.m_condition.split('&')
        // console.log(filters)
        if (filters.length > 0) {
          if (filters.length > 1) {
            vm.groupType = vm.groupTypeOptions[3]
          } else {
            var value = filters[0].split(/=(.+)/)
            if (value.length > 1 && value[0] == 'app') {
              vm.groupType = vm.groupTypeOptions.find(function(element) {
                return value[1] == element.value
              })
            }
          }
          $.each(filters, function(index, filter) {
            var value = filter.split(/=(.+)/)
            if (value.length > 1) {
              // console.log(v/alue)
              switch (value[0]) {
                case 'fullname':
                case 'email':
                case 'status':
                case 'tags':
                case 'phoneno':
                  vm.filter[value[0]] = value[1]
                  break
                case 'messagesent':
                  var messagesent = value[1].split('__')
                  vm.filter[value[0]] = {
                    value: messagesent[1],
                    symbol: vm.symbolOptions.find(function(element) {
                      return element.value === messagesent[0] + '__'
                    })
                  }
                  break
                case 'gender':
                  var gender = value[1].split(',')
                  vm.filter.gender = vm.genderOptions.find(function(element) {
                    return element.value === gender[0]
                  })
                  break
                case 'app':
                  var app = value[1].split(',')
                  vm.filter.app = vm.channelOptions.find(function(element) {
                    return element.value === app[0]
                  })
                  break
                case 'locale':
                  var locales = value[1].split(',')
                  vm.filter.locale = []
                  $.each(locales, function(lindex, locale) {
                    $.each(vm.localeOptions, function(clindex, configLocal) {
                      if (configLocal.value === locale) {
                        vm.filter.locale.push(configLocal)
                        return false
                      }
                    })
                  })
                  break
                case 'intent':
                  if (value[1] !== '') {
                    vm.filter.intent = value[1].split(',')
                  }
                  break
                case 'timestamp_from':
                  vm.filter.activeDate.start = moment(value[1]).toDate()
                  break
                case 'timestamp_to':
                  vm.filter.activeDate.end = moment(value[1]).toDate()
                  break
                case 'registertimestamp_from':
                  vm.filter.registerDate.start = moment(value[1]).toDate()
                  break
                case 'registertimestamp_to':
                  vm.filter.registerDate.end = moment(value[1]).toDate()
                  break
              }
            }
          })
        }

        vm.name = vm.broadcast.name
        // vm.type = vm.broadcast.m_type;
        vm.type = 'json'
        vm.quick_reply = vm.broadcast.m_quick_reply
        vm.sendtype = vm.broadcast.sendtype ? vm.broadcast.sendtype : 'promotion'
        vm.pushtype = vm.broadcast.pushtype ? vm.broadcast.pushtype : 'SILENT_PUSH'

        if (vm.broadcast.m_type == 'template') {
          vm.messages = [
            [
              {
                type: 'generic',
                data: JSON.parse(vm.broadcast.m_val)
              }
            ]
          ]
        } else if (vm.broadcast.m_type == 'json') {
          vm.messages = JSON.parse(vm.broadcast.m_val)
        } else {
          var newGroup = []
          var group = vm.broadcast.m_val.split('||')
          $.each(group, function(index, messages) {
            var newMessage = []
            var group_messages = messages.split('#nl')
            $.each(group_messages, function(index, message) {
              var type = 'text'
              if (!isNaN(message)) {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              } else if (vm.isJsonParseable(message)) {
                var messageParsed = JSON.parse(message)
                newMessage.push({
                  text: messageParsed.text,
                  buttons: messageParsed.buttons,
                  type: 'button'
                })
              } else if (vm.isURL(message)) {
                newMessage.push({
                  type: 'image',
                  image_url: message
                })
              } else {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              }
            })
            newGroup.push(newMessage)
          })
          vm.messages = newGroup
        }
      } else {
        vm.broadcast = {
          m_condition: null,
          name: null,
          m_type: 'json',
          m_quick_reply: null,
          m_val: null
        }
        vm.isSave = false
        vm.isFail = false
        vm.quick_reply = vm.broadcast.m_quick_reply
        vm.messages = [[]]
        vm.choice = ''
        vm.errorTag = []
        vm.estimate_user = 0
      }
      vm.$nextTick(function() {
        if (vm.groupType.value == 'customize') {
          if (vm.$store.getters.getPackage == 'premium' && !vm.isCoachlab) {
            vm.estimateReach(vm.groupType.value)
          } else {
            vm.estimateReach('')
          }
        } else {
          vm.estimateReach(vm.groupType.value)
        }
      })

      if (vm.name == '') {
        vm.name = 'Broadcast_' + moment().format('YYYY_MM_DD_HH_mm')
      }
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      var vm = this
      vm.reset()
    },
    filter: {
      handler: function(newValue) {
        if (
          this.groupType.value == 'customize' &&
          this.$store.getters.getPackage == 'premium' &&
          !this.isCoachlab
        ) {
          this.estimateReach(this.groupType.value)
        }
      },
      deep: true
    },
    groupType: function() {}
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastManage.vue